import React, { FunctionComponent } from "react";
import { MissingComponentWarning } from "core/MissingComponentWarning";
import { objectPropertiesToArray } from "../utils/utils";
import { ComponentTypeMappings } from "./component-mappings";
import { LoadingConfig } from "./dashboard/product-template-table/utils/interfaces";

interface IComponentType extends Object {
  name: String;
  dashboardComponent?: boolean;
  supportsStatusCallback?: boolean;
  invisible?: boolean;
  entryPoint: Function;
  editorEntryPoint?: FunctionComponent<DashboardEditorProps<any>>;
  editorConfig?: EditorConfig;
}

export type ComponentTypeWithID = IComponentType & IdType;

type EditorConfig = {
  hasTitle: boolean;
};

export interface DashboardEditorProps<T> {
  config: T;
  onConfigChange: (newConfig: Partial<T>) => void;
}

export interface IProductTemplateTableEditor {
  id?: number;
  safeName: string;
  transposed?: boolean;
  showTitle?: boolean;
  updateFrequency?: number;
  hiddenColumns?: Array<string>;
  onlyShownColumns?: Array<string>;
  itemsPerPage?: number;
  overrideLoadingConfig?: LoadingConfig;
  filter?: string;
  defaultFilter?: string;
  hideDates?: boolean;
  showFilter?: boolean;
  allowAddEntry?: boolean;
  allowRowEdit?: boolean;
  showTotals?: boolean;
  hidePagination?: boolean;
}

export interface IComponentTypeMapping {
  [key: string]: IComponentType;
}

export function loadComponentModule(type: keyof IComponentTypeMapping) {
  if (!(type in ComponentTypeMappings)) {
    console.warn(`Can't map unknown component type: ${type}`);
    return <MissingComponentWarning componentId={type as string} />;
  }
  return ComponentTypeMappings[type].entryPoint();
}

export function loadEditorModule(type: keyof IComponentTypeMapping) {
  if (!(type in ComponentTypeMappings)) {
    console.warn(`Can't map unknown component type: ${type}`);
    return undefined;
  }
  return ComponentTypeMappings[type].editorEntryPoint;
}

export function getComponentType(type: keyof IComponentTypeMapping): IComponentType | undefined {
  if (!(type in ComponentTypeMappings)) {
    return undefined;
  }

  return ComponentTypeMappings[type];
}

export function getDashboardComponentTypes(): ComponentTypeWithID[] {
  return objectPropertiesToArray(ComponentTypeMappings).filter(
    type => type.dashboardComponent
  ) as ComponentTypeWithID[];
}
